import React, { useEffect, useState } from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import { IconLoadSpinner } from '../common/svgicons/LoadSpinner';

type WcbButtonProps = {
    iimclient: ConfigClientType;
    clickButton: Function;
    initState?: number;
};

const WcbButton = ({ iimclient, clickButton, initState }: WcbButtonProps) => {
    const { segment } = iimclient;
    const buttonText = (segment && segment.buttontext) || 'buttontext';
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(false);
    }, [initState]);

    const handleClick = () => {
        setIsLoading(true);
        clickButton();
    };

    return (
        <button
            id="wcb-btn"
            type="button"
            role="button"
            className={`if button primary u-margin-top--16 loader-btn ${
                isLoading ? 'is-loading' : ''
            }`}
            onClick={handleClick}
        >
            <span id="wcb-buttontext">{buttonText}</span>
            <div className="load-spinner" aria-hidden="true">
                <IconLoadSpinner width="32px" height="32px" color="#333" />{' '}
                {/* check these values */}
            </div>
        </button>
    );
};

export default WcbButton;
